<template>
  <div id="subChangeGoodBadType" v-loading="loading">
    <v-container :left="true" :title="title" :height="'0.6rem'" @esc="esc">
      <v-input :config="config" :models="models" :rules="rules" @complete="complete" @esc="esc" ref="models" slot="content"></v-input>
      <v-foot :btn-config="btnConfig" @nextStep="nextStep" slot="footer"></v-foot>
    </v-container>
  </div>
</template>

<script>
import container from "../../commons/Container"
import input from "../../commons/Input"
import foot from "../../commons/Footer"
import {
  getBusinessNumber,
  queryTaskManagerUserDetail,
  verifyChangeGoodBadType
} from "@/api/change/change";
import baseMixin from "@/mixins/baseMixin";

export default {
  name: "subChangeGoodBadType",
  mixins: [baseMixin],
  data() {
    return {
      loading: false,
      title: this.$t('module.subChangeGoodBadTypeTitle'),
      config: [
        {label: this.$t('module.transKey'), prop: "transKey", disabled: true},
        {label: this.$t('module.transType'), prop: "transType", type: "select", disabled: false, options: this.getOptions("/querycodeLkup/RTX_YUM_TRANS_TYPE")},
        {label: this.$t('module.fromLoc'), prop: "fromLoc", disabled: false},
        {label: this.$t('module.fromId'), prop: "fromId", disabled: false},
        {label: this.$t('module.toLoc'), prop: "toLoc", disabled: false},
        {label: this.$t('module.toId'), prop: "toId", disabled: false},
        {label: this.$t('module.sku'), prop: "sku", disabled: false}
      ],
      models: {
        // transKey: undefined,
        // transType: 10,
        // fromLoc: '1A-01-01-01',
        // fromId: 'R000000347',
        // toLoc: 'PENDINGLOC',
        // toId: 2,
        // sku: 'HB5900602-2'
        transKey: undefined,
        transType: undefined,
        fromLoc: undefined,
        fromId: undefined,
        toLoc: undefined,
        toId: undefined,
        sku: undefined
      },
      rules: {
        transKey: [
          {required: true, message: this.$ScanPlease('module.transKey'), trigger: " "},
        ],
        transType: [
          {required: true, message: this.$ScanPlease('module.transType'), trigger: " "},
        ],
        fromLoc: [
          {required: true, message: this.$ScanPlease('module.fromLoc'), trigger: " "},
        ],
        fromId: [
          {required: true, message: this.$ScanPlease('module.fromId'), trigger: " "},
        ],
        toLoc: [
          {required: true, message: this.$ScanPlease('module.toLoc'), trigger: " "},
        ],
        toId: [
          {required: true, message: this.$ScanPlease('module.toId'), trigger: " "},
        ],
        sku: [
          {required: true, message: this.$ScanPlease('module.sku'), trigger: " "},
        ]
      },
      btnConfig: [
        {label: this.$SelectPlease('module.lot'), invalid: "nextStep", authCode: 'RF032501'},
      ]
    }
  },
  methods: {
    esc() {
      this.$router.go(-1);
    },
    nextStep() {
      // 验证参数
      this.$refs.models.submit(7, 2);
      // 验证成功子组件调用父组件函数 complete
    },
    getBusinessNumber() {

      getBusinessNumber().then((res)=> {
        let data = res.data;
        if (res.status === 200 && data.returnCode === "200") {
          this.models.transKey = data.data;
        } else {
          return this.$message.error(data.returnMgr);
        }
      });
    },
    queryTaskManagerUserDetail() {

      queryTaskManagerUserDetail().then((res)=> {
        let data = res.data;
        if (res.status === 200 && data.returnCode === "200") {
          if (data.data === 0) {
            this.$message.error(this.$t('module.noOperationPermission'));
            return this.$router.go(-1);
          } else {
            // 调用转移编号
            this.getBusinessNumber();
          }
        } else {
          return this.$message.error(data.returnMgr);
        }
      });
    },
    complete(model, ref, callback) {
      this.loading = true;
      try {
        verifyChangeGoodBadType(model).then((res) => {

          let data = res.data;
          if (res.status === 200 && data.returnCode === "200") {
            let toData = data.data;
            toData.sku = this.models.sku;
            this.$router.push({name: "subChangeGoodBadTypeBatch", params: {data: toData}});
          } else {
            this.$message.error(data.returnMgr);
          }
        });
      } catch (error) {
        this.$message.error(error)
      } finally {
        this.loading = false;
      }
    }
  },
  mounted() {
    this.queryTaskManagerUserDetail();
  },
  components: {
    "v-container": container,
    "v-input": input,
    "v-foot": foot
  }
}

</script>
<style>

</style>